import * as React from 'react';

export function Progress({
  value = 0,
  max = 100,
  className = '',
  ...props
}: React.HTMLAttributes<HTMLDivElement> & { value?: number; max?: number }) {
  const pct = Math.min(Math.max((value / max) * 100, 0), 100);
  return (
    <div
      role="progressbar"
      aria-valuenow={value}
      aria-valuemin={0}
      aria-valuemax={max}
      className={`shadcn-progress ${className}`.trim()}
      {...props}
    >
      <div className="shadcn-progress-indicator" style={{ transform: `translateX(-${100 - pct}%)` }} />
    </div>
  );
}
